import React from 'react'
import {useReport} from '../../../@types'

const Footer = () => {

    const {administration: {data: {footer}}} = useReport()

    return <div dangerouslySetInnerHTML={{__html: footer.text}} />
}

export {Footer}